import jwt from 'jsonwebtoken'
import store from '@/store'
export default {
  methods: {
    getCredentialFromToken (webappUserCredentials) {
      const token = store.getters['auth/authToken']
      if (token) {
        const tokenInfo = jwt.decode(token)
        return webappUserCredentials.find(
          (item) => item.id === tokenInfo.sub
        )
      } else {
        return null
      }
    },
  },
}
